import { Fragment } from "react";
import { connect } from "react-redux";
import { addToCart, addToWishList } from "../../store/actions/action";
import api from "../../api";
import Navbar2 from "../../components/Navbar2/Navbar2";
import Hero6 from "../../components/hero6/hero6";
import ServiceSection from "../../components/ServiceSection/ServiceSection";
import Categorys from "../../components/Categorys/Categorys";
import Product2 from "../../components/Product2/Product2";
import FunFact from "../../components/FunFact/FunFact";
import Testimonial2 from "../../components/Testimonial2/Testimonial2";
import TeamSection from "../../components/TeamSection/TeamSection";
import PartnerSection from "../../components/PartnerSection";
import Footer from "../../components/footer/Footer";
import Scrollbar from "../../components/scrollbar/scrollbar";
import { ProductItem } from "../../store/actions/action";

interface HomePage6Props {
  addToCart: (product: ProductItem, qty?: number) => void;
  addToWishList: (product: ProductItem) => void;
}

const HomePage6: React.FC<HomePage6Props> = ({ addToCart, addToWishList }) => {
  const productsArray = api();

  const addToCartProduct = (product: ProductItem, qty = 1) => {
    addToCart(product, qty);
  };

  const addToWishListProduct = (product: ProductItem) => {
    addToWishList(product);
  };

  return (
    <Fragment>
      <Navbar2 hclass="header-style-s5" />
      <Hero6 />
      <ServiceSection sClass="s2" />
      <Categorys />
      <Product2
        addToCartProduct={addToCartProduct}
        addToWishListProduct={addToWishListProduct}
        products={productsArray}
      />
      <FunFact fClass="wpo-fun-fact-section-s2" />
      <Testimonial2 />
      <TeamSection tClass="wpo-team-section-s2" />
      <PartnerSection />
      <Footer footerClass="wpo-site-footer-s2" />
      <Scrollbar />
    </Fragment>
  );
};

export default connect(null, { addToCart, addToWishList })(HomePage6);
